import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  items: [], // [{ productId, quantity }]
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    addToCart(state, action) {
      const { productId, quantity } = action.payload;
      const existingItem = state.items.find(item => item.productId === productId);

      if (existingItem) {
        existingItem.quantity += quantity;
      } else {
        state.items.push({ productId, quantity });
      }
    },

    updateCartItemQuantity(state, action) {
      const { productId, quantity } = action.payload;
      const item = state.items.find(item => item.productId === productId);

      if (item) {
        item.quantity = quantity;
      }

      // If all items have quantity 0, reset cart
      const allZero = state.items.every(item => item.quantity <= 0);
      if (allZero) {
        state.items = [];
      } else {
        // Remove items that became 0 individually (optional based on your logic)
        state.items = state.items.filter(item => item.quantity > 0);
      }
    },

    removeFromCart(state, action) {
      const productId = action.payload;
      state.items = state.items.filter(item => item.productId !== productId);
    },

    clearCart(state) {
      state.items = [];
    }
  }
});

export const { addToCart, updateCartItemQuantity, removeFromCart, clearCart } = cartSlice.actions;
export default cartSlice.reducer;
